import React from "react";
import Modal from "@mui/material/Modal";
import "./PostEntryModal.scss";
import Close from "../../images/close-light.svg";
import handleChange from "../../hooks/handleChange";

function PostEntryModal({ open, handleClose, selectedUserData }) {
  const [searchInput, setSearchText, resetSearchInput] = handleChange();
  const [sourceAmount, setSourceAmount, resetSourceAmount] = handleChange();
  const [targetAmount, setTargetAmount, resetTargetAmount] = handleChange();
  const [note, setNote, resetNote] = handleChange();

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="post-entry-container"
        style={{
          position: "fixed",
          //   transform: "translate(116px, 96px)",
          zIndex: 9999,
          display: "flex",
          //   alignItems: "center",
          //   justifyContent: "center",
          //   width: "80%",
        }}
      >
        <div className="centered-content">
          <div className="text-end pointer">
            <img src={Close} onClick={handleClose} loading="lazy" />
          </div>
          <div className="post-entry-form-container container">
            <div className="row justify-content-around">
              <div className="col-6">
                <select>
                  <option value="deposit">Deposit</option>
                  <option value="transfer">Transfer</option>
                  <option value="adjustment">Adjustment</option>
                </select>
              </div>
              <div className="col-6">
                <input
                  type="text"
                  value={searchInput}
                  onChange={setSearchText}
                  placeholder="Search"
                />
              </div>
            </div>
            <div className="post-entry-account-containers">
              <div className="row justify-content-around">
                <div className="col-5">
                  <select>
                    <option value="deposit">Source Account</option>
                  </select>
                </div>
                <div className="col-2 currency-box text-center">ZAR</div>
                <div className="col-5">
                  <input
                    type="number"
                    value={sourceAmount}
                    onChange={setSourceAmount}
                    placeholder="Source Amount"
                  />
                </div>
              </div>
              <div className="row justify-content-around mt-3">
                <div className="col-5">
                  <select disabled={selectedUserData ? true : false}>
                    {selectedUserData ? (
                      <option
                        value={selectedUserData.User.accountID}
                        selected={true}
                      >
                        {selectedUserData.User.firstName}{" "}
                        {selectedUserData.User.lastName}
                      </option>
                    ) : (
                      <option value="deposit">Target Account</option>
                    )}
                  </select>
                </div>
                <div className="col-2 text-center"></div>
                <div className="col-5">
                  <input
                    type="number"
                    value={targetAmount}
                    onChange={setTargetAmount}
                    placeholder="Target Amount"
                  />
                </div>

                <div className="row mt-3">
                  <input
                    type="textarea"
                    value={note}
                    onChange={setNote}
                    placeholder="Note"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <div className="post-entry-confirm mt-4">Post Entry</div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default PostEntryModal;
